import { Alert, Box, Button, CircularProgress } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import { PATHS } from '../../constants'
import { authenticationService, signupWithToken } from '../../Utilities/authenticationService'
import PageWithTitleLayout from '../Layout/PageWithTitleLayout'
import { theme } from '../Layout/Layout'
import * as Sentry from '@sentry/react'

const EmailConfirmation = ({ history }) => {
    const { token } = useParams()
    const [signupSuccess, setSignupSuccess] = useState(null)
    const [errorMsg, setErrorMsg] = useState('')

    useEffect(() => {
        if (!token) return
        authenticationService.logout()
            .catch(() => {})
            .finally(() => {
                signupWithToken(token)
                    .then(res => {
                        if (res.status === 200) {
                            setSignupSuccess(true)
                        }
                    })
                    .catch(e => {
                        Sentry.captureException(e)
                        if (e.response?.data.confirmation_token) {
                            setErrorMsg('トークンが失効しましたので、トークンの再発行をお願いします')
                        }
                        if (e.response?.data.email) {
                            setErrorMsg('ユーザー登録は既に完了済みです。以下のリンクからログインしてください')
                        }
                        setSignupSuccess(false)
                    })
            })
    }, [token])

    const shell = content => (
        <ThemeProvider theme={theme}>
            <PageWithTitleLayout title="メールアドレス確認" titleOnly={true}>
                {content}
            </PageWithTitleLayout>
        </ThemeProvider>
    )

    const loginButton = (
        <Button
            variant="contained"
            color="paloBlue"
            sx={{ marginTop: '1rem', height: '42px' }}
            onClick={() => history.push(PATHS.login)}
        >
            ログイン画面へ
        </Button>
    )

    if (signupSuccess === null) {
        return shell(
            <CircularProgress sx={{ display: 'block', mx: 'auto', my: '2rem' }} aria-label="confirming" />
        )
    }
    if (signupSuccess === false) {
        return shell(
            <Box className="input-box shrinkable">
                <Alert severity="error" sx={{ mt: '1rem' }}>
                    {errorMsg.length > 0 ? errorMsg : '登録に失敗しました。しばらくしてから再度お試しください'}
                </Alert>
                {loginButton}
            </Box>
        )
    }
    return shell(
        <Box className="input-box shrinkable">
            <Alert severity="success" sx={{ mt: '1rem' }}>
                メールアドレスを認証しました。続いてログインをしてください。
            </Alert>
            {loginButton}
        </Box>
    )
}

export default EmailConfirmation
